import { useState, useEffect } from 'react';
import { db } from '../firebase/config';
import { collection, onSnapshot } from 'firebase/firestore';

export const useUserData = () => {
  const [users, setUsers] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen to the 'users' collection
    const unsubUsers = onSnapshot(collection(db, 'users'), (userSnapshot) => {
      const usersData = userSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      
      // Once we have users, listen to the 'documents' collection
      const unsubDocs = onSnapshot(collection(db, 'documents'), (docSnapshot) => {
        const allDocs = docSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setDocuments(allDocs); // Set the raw documents list

        // Aggregate data: add document counts to each user
        const usersWithDocCounts = usersData.map(user => {
          const userDocs = allDocs.filter(doc => doc.userId === user.id);
          const pendingCount = userDocs.filter(doc => doc.status === 'Pending').length;
          return {
            ...user,
            docCount: userDocs.length,
            pendingCount // Add pendingCount for use in DataEntryDashboard
          };
        });

        setUsers(usersWithDocCounts); // Set the fully aggregated user list
        setLoading(false);
      });
      
      // Cleanup function for the documents listener
      return () => unsubDocs();
    });

    // Cleanup function for the users listener
    return () => unsubUsers();
  }, []); // Empty dependency array means this runs once on mount

  return { users, documents, loading };
};